export default __webpack_public_path__ + "static/media/7524_143681.5ae9cdd9.svg";